import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import InternalGate from './pages/InternalGate';
import './assets/scss/main.scss';
import { registerServiceWorker } from './utils/sw-register';

// InternalGate is a passthrough unless VITE_INTERNAL_ONLY === '1' (dev/stage),
// so it's safe to wrap unconditionally — prod builds render straight through.
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <InternalGate>
      <App />
    </InternalGate>
  </React.StrictMode>
);

// Register service worker for PWA/offline support
registerServiceWorker();
